import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
function getParentNode(items, child) {
  if (!child) return undefined;
  return items.find(function (item) {
    return item.id === child.parent_id;
  });
}

/**
 * Given a flat list of nestable items and one of the items,
 * this function returns the ids of all nodes in the path of the child.
 */

export function getAllParentIds(items, child) {
  var parentNode = getParentNode(items, child);
  if (!parentNode) {
    return [];
  }
  return [parentNode.id, getAllParentIds(items, parentNode)].flat();
}